import { Button, Modal } from "antd";
import GuideBetaDisclaimer from "./GuideBetaDisclaimer";

// VIVA-1165 — el checkout de una guía en Beta muestra el disclaimer ANTES de
// confirmar el pago.
//
// Es un paso propio y no una línea más del panel: al pulsar «Comprar guía» en
// una guía Beta se abre este aviso, y SOLO «Continuar al pago» dispara el flujo
// de cobro (crear el PaymentIntent y abrir Stripe). Así nadie llega a la
// pasarela sin haber tenido el disclaimer enfrente. Cancelar no crea nada.
//
// Una guía sin estado Beta no pasa por aquí: el panel va directo al pago
// (criterio negativo de VIVA-1165).
const GuideBetaConfirmModal = ({ open, guide, texts, isEnglish, t, onContinue, onCancel }) => (
  <Modal
    open={open}
    onCancel={onCancel}
    footer={null}
    destroyOnClose
    title={t("betaConfirmTitle")}
    zIndex={3000}
  >
    <GuideBetaDisclaimer
      guide={guide}
      texts={texts}
      isEnglish={isEnglish}
      className="g2-beta-disclaimer--confirm"
    />
    <div className="g2-payment-actions">
      <Button onClick={onCancel}>{t("cancel")}</Button>
      <Button type="primary" onClick={onContinue}>
        {t("betaConfirmContinue")}
      </Button>
    </div>
  </Modal>
);

export default GuideBetaConfirmModal;
